import type { useTranslation } from 'react-i18next'
import { z } from 'zod'

export const getSchema = (
  t: ReturnType<typeof useTranslation>['t'],
  requireProductSelection: boolean
) =>
  z.object({
    billingParty: z
      .enum(['student', 'invoicing'])
      .optional()
      .refine((val) => !requireProductSelection || val !== undefined, {
        message: t('lti.configuration.please_select_billing_party'),
      }),
    estimatedNumberOfUsers: z.coerce.number().min(1, {
      message: t('lti.configuration.estimated_number_of_users_empty'),
    }),

    estimatedNumberOfExperiences: z.coerce.number().min(1, {
      message: t('lti.configuration.estimated_number_of_experiences_empty'),
    }),

    selectedProduct: z
      .object({
        productId: z.string().optional(),
        sectionPassPrice: z.number(),
        sectionPassQuantity: z.number(),
        sectionPassProductName: z.string().optional(),
        isCustom: z.boolean(),
      })
      .optional()
      .refine((val) => !requireProductSelection || val !== undefined, {
        message: t('lti.configuration.please_select_pricing_option'),
      }),
  })

export type FormValues = z.infer<ReturnType<typeof getSchema>>
